<template lang='pug'>
  .fpui-dropdown(v-fp-click-outside='close', :class='{ active }')
    slot(name='header')
    slot(name='options')
</template>

<script>

export default {
  data () {
    return {
      active: false
    }
  },
  methods: {
    toggle () {
      this.active = !this.active
    },
    close () { this.active = false }
  }
}
</script>

<style lang='less'>
.fpui-dropdown {
  position: relative;
  &.active {
    .fpui-dropdown-head {
      color:#000;
    }
    .fpui-dropdown-options {
      display: block;
      cursor: pointer;
      max-height: 400px;
      overflow: auto;
    }
  }
}

</style>
